import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview", "image_box", "error", "drop"]
  static values = {
    url: String,
    model: String
  }

  imageSizeOver(file) {
    const fileSize = (file.size) / 1000
    if (fileSize > 10000) {
      return true
    } else {
      return false
    }
  }

  dragover(e) {
    e.preventDefault()
    this.dropTarget.classList.remove("bg-gray-50")
    this.dropTarget.classList.add("bg-gray-200")
  }

  dragleave(e) {
    e.preventDefault()
    this.dropTarget.classList.remove("bg-gray-200")
    this.dropTarget.classList.add("bg-gray-50")
  }

  dropImages(e) {
    e.preventDefault()
    this.dropTarget.classList.remove("bg-gray-200")
    this.dropTarget.classList.add("bg-gray-50")

    this.errorTarget.textContent = ""
    const uploadedFilesCount = this.previewTarget.querySelectorAll(".image-box").length
    const files = e.dataTransfer.files // ドラッグ&ドロップした画像ファイルを読み込む
    if (files.length + uploadedFilesCount > 10) {
      this.errorTarget.textContent = "画像アップロード上限は最大10枚です。"
    } else {
      for (const file of files) {
        if (this.imageSizeOver(file)) {
          this.errorTarget.textContent = "ファイルサイズの上限(1枚あたり5MB)を超えている画像はアップロードできません。"
        } else {
          this.uploadImage(file) // ファイルのアップロード
        }
      }
    }
    this.selectTarget.value = "" // 選択ファイルのリセット
  }

  selectImages() {
    this.errorTarget.textContent = ""
    const uploadedFilesCount = this.previewTarget.querySelectorAll(".image-box").length
    const files = this.selectTargets[0].files
    if (files.length + uploadedFilesCount > 10) {
      this.errorTarget.textContent = "画像アップロード上限は最大10枚です。"
    } else {
      for (const file of files) {
        if (this.imageSizeOver(file)) {
          this.errorTarget.textContent = "ファイルサイズの上限(1枚あたり5MB)を超えている画像はアップロードできません。"
        } else {
          this.uploadImage(file) // ファイルのアップロード
        }
      }
    }
    this.selectTarget.value = "" // 選択ファイルのリセット
  }

  uploadImage(file) {
    const csrfToken = document.getElementsByName('csrf-token')[0].content // CSRFトークンを取得
    const formData = new FormData()
    formData.append("image", file) // formDataオブジェクトに画像ファイルをセット
    const options = {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body: formData
    }
    /* fetchで画像ファイルをPostコントローラー(upload_imageアクション)に送信 */
    fetch(this.urlValue, options)
      .then(response => response.json())
      .then(data => { // Postコントローラーからのレスポンス(blobデータ)
        this.previewImage(file, data.id) // 画像プレビューアクションにblobデータのidを受け渡す
      })
      .catch((error) => {
        console.error(error)
      })
  }

  /* 画像プレビュー */
  previewImage(file, id) {
    const preview = this.previewTarget // プレビュー表示用の<div>要素
    const model = this.modelValue
    const fileReader = new FileReader()
    const setAttr = (element, obj) => { // 属性設定用の関数
      Object.keys(obj).forEach((key) => {
        element.setAttribute(key, obj[key])
      })
    }
    fileReader.readAsDataURL(file) // ファイルをData URIとして読み込む
    fileReader.onload = (function () { // ファイル読み込み時の処理
      const img = new Image()
      const imgBox = document.createElement("div")
      const imgInnerBox = document.createElement("div")
      const deleteBtn = document.createElement("a")
      const hiddenField = document.createElement("input")
      const imgBoxAttr = { // imgBoxに設定する属性
        "class": "image-box inline-flex mx-1 mb-5",
        "data-controller": "image-multiple-form",
        "data-image-multiple-form-target": "image_box",
      }
      const imgInnerBoxAttr = { // imgInnerBoxに設定する属性
        "class": "text-center"
      }
      const deleteBtnAttr = { // deleteBtnに設定する属性
        "class": "link cursor-pointer",
        "data-action": "click->image-multiple-form#deleteImage"
      }
      const hiddenFieldAttr = { // hiddenFieldに設定する属性
        "name": `${model}[images][]`,
        "style": "none",
        "type": "hidden",
        "value": id, // 受け取ったidをセット
      }
      setAttr(imgBox, imgBoxAttr)
      setAttr(imgInnerBox, imgInnerBoxAttr)
      setAttr(deleteBtn, deleteBtnAttr)
      setAttr(hiddenField, hiddenFieldAttr)

      deleteBtn.textContent = "削除"

      imgBox.appendChild(imgInnerBox)
      imgInnerBox.appendChild(img)
      imgInnerBox.appendChild(deleteBtn)
      imgInnerBox.appendChild(hiddenField)
      img.src = this.result
      img.width = 100;

      preview.appendChild(imgBox) // プレビュー表示用の<div>要素の中にimgBox（プレビュー画像の要素）を入れる
    })
  }

  /* プレビュー画像の削除 */
  deleteImage() {
    this.image_boxTarget.remove()
  }

  replaceImage(event) {
    const oldImg = event.currentTarget
    const hiddenField = oldImg.closest(".text-center").querySelector("input[type='hidden']")
    const fileInput = document.createElement("input")
    fileInput.type = "file"
    fileInput.accept = "image/*"

    fileInput.onchange = (e) => {
      const file = e.target.files[0]
      if (!file) return

      if (this.imageSizeOver(file)) {
        this.errorTarget.textContent = "ファイルサイズの上限(1枚あたり5MB)を超えています。"
        return
      }

      const csrfToken = document.getElementsByName('csrf-token')[0].content
      const formData = new FormData()
      formData.append("image", file)

      // 新しい画像をサーバーにアップロード
      fetch(this.urlValue, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken },
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // hidden_field の値だけ更新
          hiddenField.value = data.id

          // 既存の <img> の src を更新する
          const reader = new FileReader()
          reader.onload = (r) => {
            oldImg.src = r.target.result
          }
          reader.readAsDataURL(file)
        })
        .catch((error) => console.error(error))
    }

    fileInput.click()
  }
}